<template>

  <div>
    
    <h1>{{$t('Password reset')}}</h1>

    
    <form @submit.prevent="askForReset" v-if="!resetAsked">

    <div class="flex">
      <p>
        {{$t("pwd-intro")}}
      </p>
    </div>
      <p>
        <label for="signin_email">
          <span>{{$t('Enter your e-mail address')}}:</span>
          <input type="email" name="email" id="signin_email" :placeholder="$t('E-mail address')" required  v-model="userEmail" />
          <span class="error" for="email"></span>
        </label>
      </p>

      <p>
        <input type="submit" :value="$t('Reset my password')" class="btn_blue">
      </p>
    </form>


    <div v-if="resetAsked">
      
      <p v-if="!resetEnded">
        <span v-html="$t('reset-ok', { mail: userEmail })"></span>
      </p>

      <form @submit.prevent="finishReset" v-if="!resetEnded">
        <p>
          <label for="verification_code">
            <span>{{$t('Verification code')}}:</span>
            <input type="text" name="verification_code" id="verification_code" :placeholder="$t('Enter code here')" required  v-model="verificationCode" />
            <span class="error" for="verification_code"></span>
          </label>
        </p>
        <p>
          <label for="pass_new">
            <span>{{$t('Choose a new password')}}:</span>
            <input type="password" name="pass_new" id="pass_new" :placeholder="$t('New password')" required  v-model="newPass" />
            <span class="error" for="pass_new" v-show="newPassError !== ''">{{newPassError}}</span>
          </label>
        </p>
        <p>
          <label for="pass_newconfirm">
            <span>{{$t('Confirm new password')}}:</span>
            <input type="password" name="pass_newconfirm" id="pass_newconfirm" :placeholder="$t('Confirm new password')" required  v-model="newPassConfirmation" />
            <span class="error" for="pass_newconfirm" v-show="confirmPassError !== ''">{{confirmPassError}}</span>
          </label>
        </p>  
        <p>
          <input type="submit" :value="$t('Validate new password')" class="btn_blue">
        </p>
      </form>
    </div>


    <div v-if="resetEnded">
      <p>{{$t('Congrats, you just changed your password.')}}</p>
      <br>
      <router-link to="/login" replace>{{$t('Please log in again')}}</router-link>
    </div>


    <span class="error" v-show="hasResetError">
      <strong>{{resetError}}</strong>
    </span>

  </div>

</template>

<script>

import { Auth } from 'aws-amplify'

export default {
  name: 'ForgotPassword',
  
  metaInfo () { 
    return { title: this.$t("meta-title") } 
  },

  data: function() {
    return {
      
      userEmail : '',
      hasResetError : false,
      resetError: '',

      newPass : '',
      newPassConfirmation : '',  
      newPassError : '',
      confirmPassError : '',

      verificationCode : '',
    
      wait : false,
      resetAsked : false,
      resetEnded : false,
    }
  },
  methods:
  {
    
    async askForReset() {

      // Send confirmation code to user's email
      try {
        this.hasResetError = false;
        this.resetError = '';

        await Auth.forgotPassword(this.userEmail)
            .then(data => console.log(data))
            .catch(err => { throw err });

        this.resetAsked = true

        window.analytics.track('user-pwdforgot-asked')
        
      } catch (error) {
        this.hasResetError = true;

        if (error.code && error.code !== '') {
          this.resetError = error.message;
        }
        else this.resetError = this.$t('An error occurred, please retry or contact us if the problem persists.')

        window.analytics.track('user-pwdforgot-asked-error', error)

      }

    },


    async finishReset() {

      if (this.newPass !== this.newPassConfirmation) {
        this.newPassError = this.$t('New password and confirmation does not match.')
        this.confirmPassError = this.$t('New password and confirmation does not match.')
      }
      else {
        
        try {
          
          this.hasResetError = false;
          this.resetError = '';

          await Auth.forgotPasswordSubmit(this.userEmail, this.verificationCode, this.newPass)
                      .then(data => console.log(data))
                      .catch(err => { throw err });

          this.resetEnded = true;

          window.analytics.track('user-pwdforgot-changed')
          
        } catch (error) {

          window.analytics.track('user-pwdforgot-changed-error', error)
          
          this.hasResetError = true;

          if (error.code && error.code !== '') {
            this.resetError = error.message;
          }
          else this.resetError = this.$t('An error occurred, please retry or contact us if the problem persists.')
          
        }

      }

    }

  },
  mounted(){

    // this.$gtag.event('forgot-password')
    
  }
  
}
</script>



<i18n>
{
  "en": {
    "meta-title" : "Winerz  |  Password reset",
    "Password reset": "Password reset",
    "pwd-intro": "If you've lost your password, you can ask to create a new one by filling the fields bellow :",
    "Enter your e-mail address": "Enter your e-mail address",
    "E-mail address": "E-mail address",
    "Reset my password": "Reset my password",
    "reset-ok": "We've sent you an e-mail to <strong>{mail}</strong> whith a code to reset your password.",
    "Verification code": "Verification code",
    "Enter code here": "Enter code here",
    "Choose a new password": "Choose a new password",
    "New password": "New password",
    "Confirm new password": "Confirm new password",
    "Validate new password": "Validate new password",
    "Congrats, you just changed your password.": "Congrats, you just changed your password.",
    "Please log in again": "Please log in again",
    "An error occurred, please retry or contact us if the problem persists.": "An error occurred, please retry or contact us if the problem persists.",
    "New password and confirmation does not match.": "New password and confirmation does not match."
  },
  "fr": {
    "meta-title" : "Winerz  |  Récupération de mot de passe",
    "Password reset": "Mot de passe perdu",
    "pwd-intro": "Si tu as perdu ton mot de passe, tu peux en créer un nouveau ici en renseignant les champs suivants :",
    "Enter your e-mail address": "Ton adresse e-mail",
    "E-mail address": "Entre ton e-mail",
    "Reset my password": "Nouveau mot de passe",
    "reset-ok": "nous t'avons encoyé un e-mail à <strong>{mail}</strong> avec un code, merci de le saisir.",
    "Verification code": "Code de vérification",
    "Enter code here": "Entre le code reçu ici",
    "Choose a new password": "Choisis un nouveau mot de passe",
    "New password": "Nouveau mot de passe",
    "Confirm new password": "Confirme le nouveau mot de passe",
    "Validate new password": "Valider le nouveau mot de passe",
    "Congrats, you just changed your password.": "Brevo, ton mot de passe a bien été changé.",
    "Please log in again": "Merci de te ré-identifier",
    "An error occurred, please retry or contact us if the problem persists.": "Une erreur est survenue, merci de rééssayer ou contacte-nous si le problème persiste.",
    "New password and confirmation does not match.": "Le nouveau de mot de passe et sa confirmation ne correspondent pas"
  }
}
</i18n>